var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAireL(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_045-bike-path",
    "data-name": "045-bike-path",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.666,
    height: 98.666,
    viewBox: "0 0 98.666 98.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183",
    transform: "translate(1.927 1.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    "data-name": "Trazado 288",
    d: "M80.531,116l-6.569,10.95-4.494-7.469H45.344l-4.494,7.469L34.281,116,10,150.687h94.812Z",
    transform: "translate(-10 -95.573)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_182",
    "data-name": "Grupo 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    "data-name": "Trazado 289",
    d: "M368.979,13.854a3.854,3.854,0,1,1,0,7.708H345.854a3.854,3.854,0,0,1,0-7.708h3.854A3.853,3.853,0,0,1,353.562,10h7.708a3.853,3.853,0,0,1,3.854,3.854Z",
    transform: "translate(-278.021 -10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M205.472,30l12.062,20.053-.316.191-5.964,5.964-5.781-5.781-5.781,5.781-5.964-5.964-.316-.191Z",
    transform: "translate(-158.066 -26.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    "data-name": "Trazado 291",
    d: "M36.979,13.854a3.854,3.854,0,1,1,0,7.708H13.854a3.854,3.854,0,0,1,0-7.708h3.854A3.853,3.853,0,0,1,21.562,10h7.708a3.853,3.853,0,0,1,3.854,3.854Z",
    transform: "translate(-10 -10)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_184",
    "data-name": "Grupo 184",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    "data-name": "Trazado 292",
    d: "M360.906,3.854h-2.257A5.791,5.791,0,0,0,353.2,0H345.49a5.791,5.791,0,0,0-5.451,3.854h-2.257a5.781,5.781,0,1,0,0,11.562h23.125a5.781,5.781,0,1,0,0-11.562Zm0,7.708H337.781a1.927,1.927,0,1,1,0-3.854h3.854a1.927,1.927,0,0,0,1.927-1.927,1.929,1.929,0,0,1,1.927-1.927H353.2a1.929,1.929,0,0,1,1.927,1.927,1.927,1.927,0,0,0,1.927,1.927h3.854a1.927,1.927,0,1,1,0,3.854Z",
    transform: "translate(-268.021)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_293",
    "data-name": "Trazado 293",
    d: "M96.739,362.833H72.453A9.628,9.628,0,0,0,65.1,347.425l-2.3-13.815A1.927,1.927,0,0,0,60.9,332H53.187a1.927,1.927,0,1,0,0,3.854h6.076l1.285,7.708h-17v-3.854h1.927a1.927,1.927,0,0,0,0-3.854H37.771a1.927,1.927,0,0,0,0,3.854H39.7v5.2l-2.148,3.222a9.631,9.631,0,0,0-11.336,14.705H1.927a1.927,1.927,0,0,0,0,3.854H96.739a1.927,1.927,0,0,0,0-3.854Zm-26.208-5.781a5.781,5.781,0,1,1-8.579-5.065l.9,5.382a1.927,1.927,0,1,0,3.8-.634l-.9-5.375A5.79,5.79,0,0,1,70.531,357.052Zm-9.235-9a9.632,9.632,0,0,0-4.25,14.78H41.62a9.593,9.593,0,0,0,1.738-3.854h5.975a1.927,1.927,0,0,0,1.779-1.186l4.324-10.376H61.19Zm-18.64-.637h8.6l-3.212,7.708H43.355a9.605,9.605,0,0,0-2.6-4.857Zm-14.521,9.635a5.772,5.772,0,0,1,7.2-5.6l-3.022,4.533a1.927,1.927,0,0,0,3.207,2.138l3.022-4.533a5.78,5.78,0,1,1-10.407,3.464Z",
    transform: "translate(0 -268.021)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_294",
    "data-name": "Trazado 294",
    d: "M5.781,3.854a5.781,5.781,0,1,0,0,11.562H28.906a5.781,5.781,0,1,0,0-11.562H26.649A5.791,5.791,0,0,0,21.2,0H13.49A5.791,5.791,0,0,0,8.038,3.854ZM9.635,7.708a1.927,1.927,0,0,0,1.927-1.927A1.929,1.929,0,0,1,13.49,3.854H21.2a1.929,1.929,0,0,1,1.927,1.927,1.927,1.927,0,0,0,1.927,1.927h3.854a1.927,1.927,0,1,1,0,3.854H5.781a1.927,1.927,0,1,1,0-3.854Z",
    transform: "translate(0)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 1.959,
    cy: 1.959,
    r: 1.959,
    transform: "translate(47.374 55.211)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_295",
    "data-name": "Trazado 295",
    d: "M58.006,71.26a1.927,1.927,0,0,0,0,3.854H96.74a1.927,1.927,0,0,0,1.579-3.032L74.037,37.395a1.927,1.927,0,0,0-3.231.114l-4.919,8.2-14.9-24.774a1.927,1.927,0,0,0-3.3,0l-14.9,24.774-4.919-8.2a1.927,1.927,0,0,0-3.231-.114L.349,72.082a1.927,1.927,0,0,0,1.579,3.032H40.662a1.927,1.927,0,1,0,0-3.854H21.908L37.7,45.008l4.49,4.49a1.928,1.928,0,0,0,2.725,0l4.419-4.418L53.752,49.5a1.927,1.927,0,0,0,2.725,0l4.49-4.49L76.759,71.26Zm-40.595,0H5.629L26.084,42.038l4.446,7.411Zm37.7-25.85L50.7,40.991a1.928,1.928,0,0,0-2.725,0L43.552,45.41,39.747,41.6l9.587-15.938L58.921,41.6Zm13.022,4.039,4.446-7.411L93.038,71.26H81.257Z",
    transform: "translate(0 -16.146)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAireL);
export default __webpack_public_path__ + "static/media/aire-l.fe1f066e3c2c6ccbd72ed95b7aac2981.svg";
export { ForwardRef as ReactComponent };